import type { FunctionComponent } from "preact";

interface IProps {
  paused: boolean;
  visible?: boolean;
  onToggle: () => void;
}

const PlayIcon: FunctionComponent = () => (
  <svg width="9" height="10" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M0 8.271V1.00293C0 0.672852 0.0888672 0.423177 0.266602 0.253906C0.444336 0.0846354 0.655924 0 0.901367 0C1.11719 0 1.33089 0.0613607 1.54248 0.184082L7.5791 3.69434C7.82031 3.83398 8.00016 3.97575 8.11865 4.11963C8.24137 4.26351 8.30273 4.43701 8.30273 4.64014C8.30273 4.84326 8.24137 5.01676 8.11865 5.16064C8.00016 5.30029 7.82031 5.44206 7.5791 5.58594L1.54248 9.09619C1.33089 9.21468 1.11719 9.27393 0.901367 9.27393C0.655924 9.27393 0.444336 9.18929 0.266602 9.02002C0.0888672 8.85075 0 8.60107 0 8.271Z" fill="white" />
  </svg>
);

const PauseIcon: FunctionComponent = () => (
  <svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M1.02197 11.4448C0.674967 11.4448 0.416829 11.3581 0.247559 11.1846C0.0825195 11.0153 0 10.7614 0 10.4229V1.02197C0 0.683431 0.0846354 0.429525 0.253906 0.260254C0.427409 0.0867513 0.683431 0 1.02197 0H2.5835C2.91781 0 3.1696 0.0867513 3.33887 0.260254C3.51237 0.429525 3.59912 0.683431 3.59912 1.02197V10.4229C3.59912 10.7614 3.51237 11.0153 3.33887 11.1846C3.1696 11.3581 2.91781 11.4448 2.5835 11.4448H1.02197ZM6.16357 11.4448C5.8208 11.4448 5.56478 11.3581 5.39551 11.1846C5.22624 11.0153 5.1416 10.7614 5.1416 10.4229V1.02197C5.1416 0.683431 5.22624 0.429525 5.39551 0.260254C5.56901 0.0867513 5.82503 0 6.16357 0H7.7251C8.06364 0 8.31755 0.0867513 8.48682 0.260254C8.65609 0.429525 8.74072 0.683431 8.74072 1.02197V10.4229C8.74072 10.7614 8.65609 11.0153 8.48682 11.1846C8.31755 11.3581 8.06364 11.4448 7.7251 11.4448H6.16357Z" fill="white" />
  </svg>
);

export const PlayPauseButton: FunctionComponent<IProps> = ({ paused, visible = true, onToggle }) => {
  if (!visible) return null;

  const label = paused ? 'Play' : 'Pause';

  return (
    <button
      className={`ark-play-pause-button ark-panel-control ${paused ? 'paused' : 'playing'}`}
      type="button"
      aria-label={`${label} video ad`}
      onClick={onToggle}
    >
      {paused ? <PlayIcon /> : <PauseIcon />}
    </button>
  );
};
